<script>
import ContentsWithLinks from "@/components/article/politiken/ContentsWithLinks.vue";

export default {
  name: "ArticleMeaningCompositions",
  components: { ContentsWithLinks },
  props: {
    sublemmasTwoSmsOne: {
      type: Array,
      required: true
    },
    sublemmasTwoSmsTwo: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <div
    v-if="sublemmasTwoSmsOne.length > 0 || sublemmasTwoSmsTwo.length > 0"
    class="article-content__politiken-grid"
  >
    <div class="article-content__text article-content__politiken-grid-label">
      {{ $t("article.polCurrentDada.compositions") }}
    </div>
    <div class="article-content__politiken-grid-content">
      <template v-if="sublemmasTwoSmsOne.length > 0">
        <span
          v-for="(sublemmaTwoSmsOne, sublemmaTwoSmsOneIndex) in sublemmasTwoSmsOne"
          :key="`${sublemmaTwoSmsOneIndex}_sublemmasTwoSmsOne`"
        >
          <span
            v-if="sublemmaTwoSmsOneIndex !== 0"
            class="article-content__text article-content__text--primary"
          >
            &#183;
          </span>
          <ContentsWithLinks
            :content="sublemmaTwoSmsOne"
            text-class="article-content__text article-content__text--primary"
            link-class="article-content__text article-content__text--link"
          ></ContentsWithLinks>
        </span>
      </template>
      <template v-if="sublemmasTwoSmsTwo.length > 0">
        <span
          v-for="(sublemmaTwoSmsTwo, sublemmaTwoSmsTwoIndex) in sublemmasTwoSmsTwo"
          :key="`${sublemmaTwoSmsTwoIndex}_sublemmasTwoSmsTwo`"
        >
          <span
            v-if="sublemmasTwoSmsOne.length > 0 || sublemmaTwoSmsTwoIndex !== 0"
            class="article-content__text article-content__text--primary"
          >
            &#183;
          </span>
          <ContentsWithLinks
            :content="sublemmaTwoSmsTwo"
            text-class="article-content__text article-content__text--primary"
            link-class="article-content__text article-content__text--link"
          ></ContentsWithLinks>
        </span>
      </template>
    </div>
  </div>
</template>
